import { NumberedVersion } from '../NumberedVersion';
export class WildcardVersion extends NumberedVersion {
    constructor(versionString) {
        super(versionString, 'wildcard');
    }
}
